import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Registers the service worker (src/service-worker.js) in production only.
// This is what actually makes the PWA installable on Android/desktop
// Chrome — the manifest.json alone was never enough; without a registered
// SW with a fetch handler, browsers won't fire the install prompt.
// Electron packages this same build too, but Electron never hits this
// (NODE_ENV there isn't 'production' via CRA's build served over file://,
// and even if it did, registering a SW inside the desktop app is harmless
// no-op since there's no install-prompt UI there anyway).
serviceWorkerRegistration.register();
